import { isUndefined } from "util";
import { logout} from "../core/auth";

export default function formatError(err, pg, msgDft) {
   if(!isUndefined(err.message)) {
	  console.log('primeiro if');
      console.log(err);
      if( err.message === "Network Error") {
        pg.setState({
          error: "O Servidor demorou muito para responder. Isso pode ser causado por uma instabilidade na rede ou pelo serviço estar temporariamente indisponível. Por favor, tente novamente.",
          resultsMessage: "",
        });
        return;
      } else if(err.message.toLowerCase() === 'unable to decrypt data') {
        pg.setState({
          error: "Ocorreu um erro descriptografando dados.",
          resultsMessage: "",
        });
        return;
      } else {
	    console.log('what now');
        pg.setState({
          error: err.data.message,
          resultsMessage: "",
        });
      }
    }

    if(!isUndefined(err) && !isUndefined(err.data)) {
	  	  console.log('segundo if');
      console.log(err);
      if(err.status === 408) {
        window.alert("Tempo de sessão expirado. Você será direcionado para a página inicial para reiniciao o processo de troca de senha.");
        logout();
        this.props.history.push("/");
      }
      const erro = JSON.stringify(err);
      //console.log(erro)
      const objErro = JSON.parse(erro);
      console.log(objErro);
      if(isUndefined(objErro.data.message)) {
		  console.log('5');
        if( objErro.data.indexOf("message") < 0 ) {
	        	  console.log('6');  
            if(!isUndefined(msgDft)){
	             	  console.log('7');
                this.setState({
                    error: msgDft,
                });
                return;
            }
            	  console.log('8');
            pg.setState({
                error: "Ocorreu um erro desconhecido. Reinicie o processo. Se o erro persistir, contate o administrador do Sistema.",
                resultsMessage: "",
            });
        } else {
	      	  console.log('9');
          const erro = objErro.data.substring((objErro.data.indexOf("message")+10));

          pg.setState({
            error: erro.substring(0, (erro.indexOf("\""))),
            resultsMessage: "",
          });
        }
      } else {
		  console.log('10');
	    console.log(objErro.data.message);
        pg.setState({
          error: objErro.data.message,
          resultsMessage: "",
        });
      }
    }
}

  